// extracted by mini-css-extract-plugin
export default {"title":"DocumentUploader_modal_title__eGeJE","body":"DocumentUploader_modal_body__lar1K","buttons":"DocumentUploader_modal_buttons__WDqWL"};